/*global define:false*/
define('plugins/radio/view.js',['pluginBaseView'],
    function (PluginBaseView) {
        'use strict';

        return PluginBaseView.extend({

        });


    });

